videojs.addLanguage('fr', {
  "description": "Description de la vidéo",
  "title": "Informations générales de la vidéo",
  "views": "vues"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_info/dist/lang/fr.js
// module id = 544
// module chunks = 39